import request from '@apps-common/js-client/api/request';
import {useQuery} from '@tanstack/react-query';
import {removeEmpty} from './util.js';
import {PDA_ADMIN_URL} from '@app/config';
import useOrgParams from '@app/hooks/useOrgParams';

export const getProducts = (params = {}) =>
  new Promise((resolve, reject) => {
    const config = {
      params: {
        ...params,
        limit: params.limit || 250,
      },
    };

    let allProducts = [];

    const handler = response => {
      allProducts = [...allProducts, ...(response?.data?.results ?? [])];

      const nextLink = response?.data?.meta?.next;

      if (nextLink) {
        request.get(nextLink, config).then(handler).catch(reject);
      } else {
        resolve({products: allProducts, count: response?.data?.meta?.count});
      }
    };

    request
      .get(`${PDA_ADMIN_URL}/my/products`, config)
      .then(handler)
      .catch(reject);
  });

export const queryKeys = {
  all: ['products'],
  lists: () => [...queryKeys.all, 'list'],
  list: filters => [...queryKeys.lists(), removeEmpty({...filters})],
  details: () => [...queryKeys.all, 'detail'],
  detail: id => [...queryKeys.details(), id],
};

export const useGetProducts = (queryOptions = {}) => {
  const {orgId} = useOrgParams();

  const queryParams = {
    organization_id: orgId,
  };

  return useQuery({
    queryKey: queryKeys.list({...queryParams}),
    queryFn: () => getProducts(queryParams),
    staleTime: 5 * 60 * 1000,
    select: data => {
      const products = data.products.map(product => {
        const newProduct = {
          ...product,
          ...product.product,
        };
        delete newProduct.product;
        return newProduct;
      });
      return products;
    },
    ...queryOptions,
  });
};

export const useGetProductsCount = (queryOptions = {}) => {
  return useGetProducts({
    ...queryOptions,
    select: data => data.count,
  });
};
